import { render } from "./RegisterTournamentDialog.vue?vue&type=template&id=801d28a8"
import script from "./RegisterTournamentDialog.vue?vue&type=script&lang=js"
export * from "./RegisterTournamentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__